/* Microsoft Clarity — session recordings, heatmaps, rage-click detection.
   Loads ONLY when REACT_APP_CLARITY_ID is set (so dev/test environments stay
   untracked). Get the ID: clarity.microsoft.com → New project → Setup →
   "Install manually" → the ID in the snippet, then set it in .env. */

const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

export function initClarity() {
  if (!CLARITY_ID || window.clarity) return;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
}

/* Tag the session so recordings are filterable in the Clarity dashboard:
   role (candidate/college/company/agency/admin), college linkage, plan. */
export function tagClarityUser(user) {
  if (!CLARITY_ID || !window.clarity || !user) return;
  try {
    // Stable anonymous identity (no email/PII sent — user_id is our opaque id).
    window.clarity("identify", user.user_id);
    if (user.role) window.clarity("set", "role", user.is_admin ? "admin" : user.role);
    if (user.college_id) window.clarity("set", "college", user.college_id);
    if (user.branch) window.clarity("set", "branch", user.branch);
  } catch (_) { /* analytics must never break the app */ }
}

/* Mark key funnel moments (call from feature code as needed):
   trackClarityEvent("interview_started"), ("test_submitted"), ("paywall_seen") */
export function trackClarityEvent(name) {
  if (!CLARITY_ID || !window.clarity) return;
  try { window.clarity("event", name); } catch (_) {}
}
